












import Vue from "vue";
export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    initialData: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitInput(evt: Event): void {
      this.$emit("change", (evt.target as HTMLInputElement).value);
    },
  },
});
